import { Pipe, PipeTransform } from '@angular/core';
import {CategoriaProduto } from '../enums/categoria-produto.enum';

@Pipe({
  name: 'productCategory'
})
export class ProductCategoryPipe implements PipeTransform {

  transform(value: any, args?: any, justOne: boolean = false): any {
    if(args) {
        if(args == CategoriaProduto.Tradicional && justOne) {return value.filter(x=>x.id == CategoriaProduto.Tradicional);}
        if(args == CategoriaProduto.Tradicional && !justOne) {return value.filter(x=>x.id == CategoriaProduto.Tradicional || x.id == CategoriaProduto.Flex);}
        if(args == CategoriaProduto.Flex && justOne) {return value.filter(x=> x.id == CategoriaProduto.Flex);}
        if(args == CategoriaProduto.Flex && !justOne) {return value.filter(x=>x.id == CategoriaProduto.Tradicional || x.id == CategoriaProduto.Flex);}
        if(args == CategoriaProduto.Incentivo && justOne) {return value.filter(x=>x.id == CategoriaProduto.Incentivo);}
        if(args == CategoriaProduto.Incentivo && !justOne) {return value.filter(x=>x.id == CategoriaProduto.Incentivo || x.id == CategoriaProduto.IncentivoPlus || x.id == CategoriaProduto.TradicionalPlus);}
        if(args == CategoriaProduto.IncentivoPlus && justOne) {return value.filter(x=>x.id == CategoriaProduto.IncentivoPlus);}
        if(args == CategoriaProduto.IncentivoPlus && !justOne) {return value.filter(x=>x.id == CategoriaProduto.Incentivo || x.id == CategoriaProduto.IncentivoPlus || x.id == CategoriaProduto.TradicionalPlus);}
        if(args == CategoriaProduto.TradicionalPlus && justOne) {return value.filter(x=>x.id == CategoriaProduto.TradicionalPlus);}
        if(args == CategoriaProduto.TradicionalPlus && !justOne) {return value.filter(x=>x.id == CategoriaProduto.Incentivo || x.id == CategoriaProduto.IncentivoPlus || x.id == CategoriaProduto.TradicionalPlus);}
        else {return '';}
      }
  }

}
